module.exports = __webpack_public_path__ + "media/packs/images/sea-048e992a1256d3603fd29b5c45e158f3.png";